import { NavLink } from "@/components/NavLink";
import { ArrowRight, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { blogPosts as allBlogPosts } from "@/data/blogPosts";

// Pick the 3 newest posts from the real blog data so links resolve correctly
const blogPosts = [...allBlogPosts]
  .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
  .slice(0, 3);

export const BlogPreview = () => {
  return (
    <section className="section-padding bg-muted/30" aria-labelledby="blog-heading">
      <div className="container-luxury">
        <div className="text-center space-y-4 mb-14">
          <span className="section-badge">Travel Insights</span>
          <h2 id="blog-heading" className="section-title">
            Expert Travel Tips & Guides
          </h2>
          <p className="section-subtitle">
            Expert insights from our team to help you plan unforgettable vacations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {blogPosts.map((post) => (
            <article
              key={post.slug}
              className="luxury-card overflow-hidden hover-lift group"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>
              <div className="p-6 space-y-3">
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <Calendar className="h-3.5 w-3.5" />
                  <time>{post.date}</time>
                </div>
                <h3 className="font-heading font-semibold text-lg leading-snug group-hover:text-primary transition-colors">
                  <NavLink to={`/blog/${post.slug}`}>{post.title}</NavLink>
                </h3>
                <p className="text-sm text-muted-foreground line-clamp-2 leading-relaxed">
                  {post.excerpt}
                </p>
                <NavLink
                  to={`/blog/${post.slug}`}
                  className="inline-flex items-center text-sm font-medium text-primary hover:underline pt-1"
                  aria-label={`Read more about ${post.title}`}
                >
                  Read More
                  <ArrowRight className="ml-1 h-3.5 w-3.5" />
                </NavLink>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-14">
          <Button asChild variant="outline" size="lg" className="px-8 rounded-full h-12 font-semibold">
            <NavLink to="/blog">
              View All Articles
              <ArrowRight className="ml-2 h-4 w-4" />
            </NavLink>
          </Button>
        </div>
      </div>
    </section>
  );
};